import { collaborativeUpdate, updateAction } from '../common/index';
/**
 * Collaborative Editing module for real time changes in the Spreadsheet.
 */
export class CollaborativeEditing {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    refreshClients(options) {
        updateAction(options, this.parent);
    }
    addEventListener() {
        this.parent.on(collaborativeUpdate, this.refreshClients, this);
    }
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(collaborativeUpdate, this.refreshClients);
        }
    }
    /**
     * Destroy collaborative editing module.
     *
     * @returns {void} - Destroy collaborative editing module.
     */
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
    /**
     * Get the collaborative editing module name.
     *
     * @returns {string} - Get the collaborative editing module name.
     */
    getModuleName() {
        return 'collaborativeEditing';
    }
}
